import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelDTerm } from "../../types/leveld-reports";

export const useGetLevelDTerms = (startDate?: string, endDate?: string) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchTerms = async (): Promise<LevelDTerm[]> => {
        try {
            const params = new URLSearchParams();
            
            if (startDate) {
                params.append('startDate', startDate);
            }
            if (endDate) {
                params.append('endDate', endDate);
            }

            const url = params.toString() 
                ? `/api/leveldreports/terms?${params.toString()}`
                : '/api/leveldreports/terms';
            
            const { data } = await axios.get(url);
            return data;
        } catch (error) {
            throw new Error(t("levelDReports.errors.getTerms"));
        }
    };

    return useQuery({
        queryKey: ["levelDTerms", startDate, endDate],
        queryFn: fetchTerms,
    });
};
